var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryTransportation32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1613.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Transportation32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconTransportation",
    transform: "translate(4.000000, 9.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49400542e-17,4.5 L3,4.5 L6,0.5 L14,0.5 L17,4.5 C19.2255859,4.5 20.8922526,4.5 22,4.5 C23.6616211,4.5 24,5.5 24,6.5 C24,7.16666667 24,8.5 24,10.5 L20.0609131,10.5 L20,9.5 L22.975708,9.5 C22.9919027,8.16666667 23,7.16666667 23,6.5 C23,5.5 22,5.5 22,5.5 C22,5.5 20.1666667,5.5 16.5,5.5 L13.5,1.5 L6.74291992,1.51367188 L3.5,5.5 L1,5.5 C1.00349935,6.15033408 1.00524902,7.16477907 1.00524902,8.54333496 C1.00524902,9.01867676 1.32787027,9.36894926 2.00012207,9.5 C2.18229213,9.53551277 2.84891811,9.53551277 4,9.5 L4,10.5 C3.42504883,10.5 2.75842285,10.5 2.00012207,10.5 C0.862670898,10.5 -1.69093906e-13,9.45666504 2.08166817e-16,8.5 C-1.38777878e-17,7.39379883 -5.82867088e-17,6.06046549 7.49400542e-17,4.5 Z",
    id: "Outline"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 8,
    y: 9.5,
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Window",
    x: 3,
    y: 4.5,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,12.5 C7.1045695,12.5 8,11.6045695 8,10.5 C8,9.3954305 7.1045695,8.5 6,8.5 C4.8954305,8.5 4,9.3954305 4,10.5 C4,11.6045695 4.8954305,12.5 6,12.5 Z M6,13.5 C4.34314575,13.5 3,12.1568542 3,10.5 C3,8.84314575 4.34314575,7.5 6,7.5 C7.65685425,7.5 9,8.84314575 9,10.5 C9,12.1568542 7.65685425,13.5 6,13.5 Z",
    id: "Wheel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12.5 C19.1045695,12.5 20,11.6045695 20,10.5 C20,9.3954305 19.1045695,8.5 18,8.5 C16.8954305,8.5 16,9.3954305 16,10.5 C16,11.6045695 16.8954305,12.5 18,12.5 Z M18,13.5 C16.3431458,13.5 15,12.1568542 15,10.5 C15,8.84314575 16.3431458,7.5 18,7.5 C19.6568542,7.5 21,8.84314575 21,10.5 C21,12.1568542 19.6568542,13.5 18,13.5 Z",
    id: "Wheel-Front"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryTransportation32);
export default __webpack_public_path__ + "static/media/spendCategoryTransportation32.34fb66504a393ae08bc2614b3c9f974e.svg";
export { ForwardRef as ReactComponent };